import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PhoneInput from 'react-phone-input-2'
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { Country } from "country-state-city";


// import lib
import fileObjectUrl from "../../lib/fileObjectUrl";
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from "../../lib/isEmpty";

// import api
import { updateProfile } from "../../api/users";

//import validation
import { ProfileValidation } from "./validation";


const initialFormValue = {
  firstName: "",
  lastName: "",
  address: "",
  city: "",
  country: "",
  countryCode: "",
  postalCode: "",
  phoneCode: "",
  phoneNo: "",
  profile: ""
}
let imageType = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG']

const ProfileModal = (props) => {

  //props
  const { isShow, onHide } = props;



  // state
  const [formValue, setFormValue] = useState(initialFormValue)
  const { firstName, lastName, profile, address, city, country, countryCode, postalCode, phoneCode, phoneNo } = formValue
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation()


  // redux-state
  const accountData = useSelector((state) => state.account);



  const countryArr = [];

  const countryDetails = Country.getAllCountries();
  countryDetails.map((data, i) => {
    countryArr.push({
      value: data.isoCode,
      label: data.name,
    });
  });


  const handleCountry = (e) => {
    const { name, value } = e.target;
    const getCountry = countryArr.find((el) => el.value == value);
    let formData = { ...formValue, ...{ ["country"]: getCountry.label, ["countryCode"]: getCountry.value } };
    setFormValue(formData);
    if (!isEmpty(errors)) {
      setErrors({});
    }
  };

  //function
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name == "firstName" || name == "lastName" || name == 'city') {
      if (/[^a-zA-Z ]/.test(value)) return;
    }
    if (name == "postalCode") {
      if (/[^a-zA-Z0-9]/.test(value)) return;
    }
    let formData = { ...formValue, ...{ [name]: value } };
    setFormValue(formData);
    if (!isEmpty(errors)) {
      setErrors({});
    }
  }

  const handleFile = async (e) => {
    const { name, files } = e.target;
    if (!imageType.includes(files[0].type.split('/')[1])) {
      return toastAlert("error", t('INVALID_PROFILE'), "updateProfile");

    }
    if (files[0]?.size >= 2000000) {
      return toastAlert("error", t("UPLOAD_IMAGE"), "updateProfile");
    }

    let formData = { ...formValue, ...{ [name]: files[0] } };
    setFormValue(formData);
    if (!isEmpty(errors)) {
      setErrors({});
    }
  };


  const handlePhoneNumber = (value, country) => {
    const { dialCode } = country;
    let phoneNo = value;
    let formData = formValue;
    if (dialCode) {
      formData = {
        ...formData, ...{
          phoneCode: dialCode,
          phoneNo: phoneNo.slice(dialCode.length),
        }
      }
    } else if (value) {
      formData = { ...formData, ...{ phoneNo } }
    }
    setFormValue(formData)
  }

  const handleSubmit = async () => {
    try {
      setLoader(true);
      let reqData = {
        firstName,
        lastName,
        profile,
        address,
        city,
        country: formValue.country,
        postalCode,
        phoneCode,
        phoneNo
      };
      let validationError = ProfileValidation(reqData);
      if (!isEmpty(validationError)) {
        setErrors(validationError);
        setLoader(false);
        return;
      }
      const formData = new FormData();
      formData.append("profile", profile);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("address", address);
      formData.append("city", city);
      formData.append("country", formValue.country);
      formData.append("countryCode", formValue.countryCode);
      formData.append("postalCode", postalCode);
      formData.append("phoneCode", phoneCode);
      formData.append("phoneNo", phoneNo);
      const { status, loading, message, errors } = await updateProfile(
        formData,
        dispatch
      );
      setLoader(loading);

      if (status === "success") {
        setLoader(false)
        toastAlert("success", t(message), "updateProfile");
        hanldeClose();
      } else {
        setLoader(false)
        if (errors) {
          setErrors(errors);
        } else {
          toastAlert("error", t(message), "updateProfile");
        }
      }
    } catch (err) {
      setLoader(false)
      console.log(err, 'erroror')
    }
  };

  const fetchFunction = () => {
    if (accountData) {
      let formData = {
        firstName: accountData?.firstName,
        lastName: accountData?.lastName,
        address: accountData?.address,
        country: accountData?.country,
        countryCode: accountData?.countryCode,
        city: accountData?.city,
        postalCode: accountData?.postalCode,
        profile: accountData?.profile,
        phoneCode: accountData?.phoneCode,
        phoneNo: accountData?.phoneNo,
      };
      setFormValue({ ...formValue, ...formData });
    }
  }


  const hanldeClose = () => {
    setErrors({});
    fetchFunction()
    onHide()
  }


  useEffect(() => {
    fetchFunction()
  }, [accountData])

  // console.log(formValue, 'formVlaue')

  return (
    <Modal
      show={isShow}
      onHide={hanldeClose}
      backdrop="static"
      keyboard={false}
      size="md"
      centered >
      <Modal.Header className="justify-between">
      <Modal.Title>  <h4 className="modal-title mt-0 model_head">
          {t("UPDATE_PROFILE")}
        </h4></Modal.Title>
        <button type="button" className="border-0 bg-transparent p-0" aria-label="Close" onClick={hanldeClose}>
                        <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
                        </svg>
                    </button>
      </Modal.Header>
      <Modal.Body>
        <form className="assets_form">
          <div className="mb-3">
            <label for="profile" className="form-label">
              {t("PROFILE")}
            </label>
            <span className={"text-danger"}>
              {errors && errors.profile}
            </span>
            <img
              src={fileObjectUrl(profile)}
              style={{ width: "86px" }}
              className="me-2"
            />
            <div class="custom_file_upload btn">
              {t("UPLOAD")}
              <input
                type="file"
                name="profile"
                onChange={handleFile}
              />
            </div>
            <div className="form-text ms-1">
              {t("PROFILE_RESTRICTION")}
            </div>
            {profile?.name &&
              <div className="uploaded_files_row">
                <div>
                  <i className="bi bi-file-earmark-plus"></i>
                  <span>{profile?.name}</span>
                </div>
                <div>
                  <i className="bi bi-x-circle" onClick={() => setFormValue({ ...formValue, ...{ ['profile']: "" } })}></i>
                </div>
              </div>
            }
          </div>
          <div className="mb-3">
            <label for="firstname" className="form-label">
              {t("FIRST_NAME")}
            </label>
            <input
              type="text"
              className="form-control primary_asset_inp"
              name="firstName"
              value={firstName}
              onChange={handleChange}
              placeholder={t("FIRST_NAME_PLACEHOLDER")}
            />
            <span className={"text-danger"}>
              {errors && t(errors.firstName)}
            </span>
          </div>
          <div className="mb-3">
            <label for="lastname" className="form-label">
              {t("LAST_NAME")}
            </label>
            <input
              type="text"
              className="form-control primary_asset_inp"
              name="lastName"
              value={lastName}
              onChange={handleChange}
              placeholder={t("LAST_NAME_PLACEHOLDER")}
            />
            <span className={"text-danger"}>
              {errors && t(errors.lastName)}
            </span>
          </div>
          <div className="mb-3 phone_num">
            <label for="lastname" className="form-label">
              {t("PHONE_NUMBER")}
            </label>
            <PhoneInput
              placeholder={t("PHONE_PLACEHOLDER")}
              value={phoneCode + phoneNo}
              onChange={handlePhoneNumber}
              specialLabel={false}
              enableSearch={true}
            />
            <span className={"text-danger"}>
              {errors && t(errors.phoneCode)}
            </span>
          </div>
          <div className="mb-3">
            <label for="address" className="form-label">
              {t("ADDRESS")}
            </label>
            <input
              type="text"
              className="form-control primary_asset_inp"
              name="address"
              value={address}
              onChange={handleChange}
              placeholder={t("ADDRESS_PLACEHOLDER")}
            />
            <span className={"text-danger"}>
              {errors && t(errors.address)}
            </span>
          </div>
          <div className="mb-3">
            <label for="city" className="form-label">
              {t("CITY")}
            </label>
            <input
              type="text"
              className="form-control primary_asset_inp"
              name="city"
              value={city}
              onChange={handleChange}
              placeholder={t("CITY_PLACEHOLDER")}
            />
            <span className={"text-danger"}>
              {errors && t(errors.city)}
            </span>
          </div>
          <div className="mb-3">
            <label for="country" className="form-label">
              {t("COUNTRY")}
            </label>
            <select
              name="countryCode"
              value={countryCode}
              onChange={handleCountry}
              className="form-control primary_asset_select"
            >
              <option value={""}>Select country</option>
              {countryArr.map((data, i) => {
                return (
                  <option value={data.value}>
                    {data.label}
                  </option>
                );
              })}
            </select>
            <span className={"text-danger"}>
              {errors && t(errors.country)}
            </span>
          </div>
          <div className="mb-3">
            <label for="postal" className="form-label">
              {t("POSTAL_CODE")}
            </label>
            <input
              type="text"
              className="form-control primary_asset_inp"
              name="postalCode"
              value={postalCode}
              onChange={handleChange}
              placeholder={t("POSTAL_CODE_PLACEHOLDER")}
            />
            <span className={"text-danger"}>
              {errors && t(errors.postalCode)}
            </span>
          </div>
          <div className="w-full inline-flex justify-start items-center gap-2 mt-4">
            <button type="button"
                className="flex-1 h-10 px-4 relative bg-gray-300 hover:bg-gray-400 active:bg-gray-500 active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0"
                onClick={hanldeClose}
            >
                <div className="text-center justify-center text-[#395645] text-base font-medium font-['Roobert']">{t("CANCEL")}</div>
            </button>
            {
                loader ?
                    <button type="button" className="flex-1 h-10 px-4 relative bg-[#395645] rounded-sm flex justify-center items-center overflow-hidden border-0 opacity-70 cursor-not-allowed" disabled={true}>
                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("LOADING")}...</div>
                    </button> :
                    <button type="button" onClick={handleSubmit} className="flex-1 h-10 px-4 relative bg-[#395645] hover:bg-[#2a4033] active:bg-[#1d2d24] active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0">
                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("UPDATE")}</div>
                    </button>
            }
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
